import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Pedidos",
    items: [
      { label: "Pedidos",        icon: "fas fa-shopping-basket", href: "/ListadoPedidos",       perm: "menu_pedidos"  },
      { label: "Entregar",       icon: "fas fa-truck-moving",    href: "/ListadoPendienteSurtir", perm: "menu_surtidos" },
    ],
  },
  {
    title: "Operación",
    items: [
      { label: "Devoluciones",        icon: "fas fa-undo-alt",    href: "/ListadoDevoluciones", perm: "menu_devoluciones"       },
      { label: "Venta Salderos",      icon: "fas fa-dollar-sign", href: "/VentaSalderos",       perm: "menu_pedidos"            },
      { label: "Seguimiento Pedidos", icon: "fas fa-chart-bar",   href: "/SeguimientoPedidos",  perm: "menu_seguimientoPedidos" },
    ],
  },
];

function BotonesVentas() {
  return (
    <MenuGrid
      title="Pedidos"
      subtitle="Gestión de pedidos, entregas y devoluciones de venta"
      icon="fas fa-clipboard-list"
      accent={{ color: "#3b82f6", bg: "#eff6ff" }}
      gate="menu_ventas"
      sections={SECTIONS}
    />
  );
}

export default BotonesVentas;
